import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { rrss } from "../data/links";

export default function Contact() {
  return (
  <>
   <HelmetProvider>
      <Helmet>
        <title>Contacto | ERI</title>
      </Helmet>
    </HelmetProvider>
    <div id="contact" className="content">
      <div className="content-wrapper">
        <div className="content-title">
          <h1 className="title">Contacto</h1>
          <h2 className="subtitle">
            La forma más fácil de contactar con nosotros es a través de nuestro <a className="social-url dc" title="Discord" href={rrss.dc} target="_blank" rel="noopener noreferrer">servidor de Discord</a>,
            <span className="break">aunque también puedes encontrarnos en nuestras redes sociales o escribiéndonos un correo electrónico.</span>
          </h2>
        </div>
        <div className="content-main">
          <div className="content-items">
              <a className="rrss-link" title="Email" href={rrss.gm} target="_blank" rel="noopener noreferrer"><span className="social-icon gm"></span><span className="rrss-name">cryptex.eri@gmail.com</span></a>
              <a className="rrss-link" title="X" href={rrss.x} target="_blank" rel="noopener noreferrer"><span className="social-icon x"></span><span className="rrss-name">X</span></a>
              <a className="rrss-link" title="Instagram" href={rrss.ig} target="_blank" rel="noopener noreferrer"><span className="social-icon ig"></span><span className="rrss-name">Instagram</span></a>
          </div>
          <div className="content-items">
              <a className="rrss-link" title="Discord" href={rrss.dc} target="_blank" rel="noopener noreferrer"><span className="social-icon dc"></span><span className="rrss-name">Discord</span></a>
              <a className="rrss-link" title="Paypal" href={rrss.pp} target="_blank" rel="noopener noreferrer"><span className="social-icon pp"></span><span className="rrss-name">Paypal</span></a>
              <a className="rrss-link" title="Ko-fi" href={rrss.kf} target="_blank" rel="noopener noreferrer"><span className="social-icon kf"></span><span className="rrss-name">Ko-fi</span></a>
          </div>
        </div>
      </div>
    </div>
  </>
  );
}
